module.exports = __webpack_public_path__ + "static/img/attestation.2f9f5af9.png";